// frontend/src/components/auth/RequireAuth.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

const RequireAuth = ({ children, adminOnly, officeOnly }) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // Show a spinner while checking authentication status (e.g. on hard refresh)
  // so protected routes don't paint a blank white screen until the token resolves.
  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // Redirect to login if not authenticated
  if (!currentUser) {
    // Save the attempted URL for redirecting after successful login
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly && currentUser.role !== 'admin' && currentUser.role !== 'dev') {
    // Admin only route, but user is not an admin or dev
    return <Navigate to="/dashboard" replace />;
  }

  if (officeOnly && !['admin', 'dev', 'office'].includes(currentUser.role)) {
    // Office only route, but user is not office staff, admin, or dev
    return <Navigate to="/dashboard" replace />;
  }

  // User is authenticated, render the protected route
  return children;
};

export default RequireAuth;